var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.modalAction
    ? _c(
        "b-modal",
        {
          ref: "order-convert-modal'",
          attrs: {
            id: "orderConvertModal",
            title: _vm.modalAction.Title,
            size: "xl",
            "no-close-on-backdrop": ""
          },
          on: { show: _vm.show, hide: _vm.hide },
          scopedSlots: _vm._u(
            [
              {
                key: "modal-footer",
                fn: function() {
                  return [
                    _c(
                      "div",
                      { staticClass: "w-100 text-right" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "danger", size: "sm" },
                            on: {
                              click: function($event) {
                                return _vm.closeModal()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$t("index.close")) +
                                "\n      "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant: "primary",
                              size: "sm",
                              disabled: _vm.isLoading
                            },
                            on: {
                              click: function($event) {
                                return _vm.submitModal()
                              }
                            }
                          },
                          [
                            _vm.isLoading
                              ? _c(
                                  "span",
                                  [_c("b-spinner", { attrs: { small: "" } })],
                                  1
                                )
                              : _c("span", [
                                  _vm._v(_vm._s(_vm.$t("index.approve")))
                                ])
                          ]
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ],
            null,
            false,
            73072477
          )
        },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("index.Convert.Code"),
                        md: "4",
                        lg: "4"
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: { type: "text", readonly: "" },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("index.Convert.Warehouse"),
                        md: "4",
                        lg: "4"
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: { type: "text", readonly: "" },
                        model: {
                          value: _vm.warehouse,
                          callback: function($$v) {
                            _vm.warehouse = $$v
                          },
                          expression: "warehouse"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("index.Convert.InvoiceKindId"),
                        error: _vm.$v.form.InvoiceKindId,
                        required: true,
                        md: "4",
                        lg: "4"
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: { options: _vm.invoiceTypes, label: "Label" },
                        on: {
                          input: function($event) {
                            return _vm.selectedType("InvoiceKindId", $event)
                          }
                        },
                        model: {
                          value: _vm.invoiceType,
                          callback: function($$v) {
                            _vm.invoiceType = $$v
                          },
                          expression: "invoiceType"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("index.Convert.DocumentNumber"),
                        md: "4",
                        lg: "4"
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.form.DocumentNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "DocumentNumber", $$v)
                          },
                          expression: "form.DocumentNumber"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("index.Convert.Employee"),
                        md: "4",
                        lg: "4"
                      }
                    },
                    [
                      _c(
                        "v-select",
                        {
                          attrs: {
                            value: _vm.employee,
                            options: _vm.employees,
                            label: "Description1",
                            filterable: false
                          },
                          on: {
                            search: _vm.onEmployeeSearch,
                            input: function($event) {
                              return _vm.selectedSearchType(
                                "RepresentativeId",
                                $event
                              )
                            }
                          }
                        },
                        [
                          _c("template", { slot: "no-options" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("insert.min3")) +
                                "\n          "
                            )
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("index.Convert.TransactionDate"),
                        md: "4",
                        lg: "4"
                      }
                    },
                    [
                      _c("NextDatePicker", {
                        model: {
                          value: _vm.form.documentDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "documentDate", $$v)
                          },
                          expression: "form.documentDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _vm.orderLines
                        ? _c("b-table", {
                            attrs: {
                              items: _vm.orderLines,
                              fields: _vm.fields,
                              "sticky-header": "",
                              busy: _vm.tableBusy
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "head()",
                                  fn: function(data) {
                                    return [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.$t(data.label)) +
                                          "\n          "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "table-busy",
                                  fn: function() {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-center text-danger my-2"
                                        },
                                        [
                                          _c("b-spinner", {
                                            staticClass: "align-middle"
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "cell(Count)",
                                  fn: function(data) {
                                    return [
                                      _c("NextInput", {
                                        attrs: { type: "number", min: "1" },
                                        on: {
                                          keypress: function($event) {
                                            return _vm.onlyForCurrencyDot(
                                              $event
                                            )
                                          }
                                        },
                                        model: {
                                          value: data.item.ConversionQuantity,
                                          callback: function($$v) {
                                            _vm.$set(
                                              data.item,
                                              "ConversionQuantity",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "data.item.ConversionQuantity"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              163106744
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44837f76", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44837f76","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Actions/OrderConvertModal.vue
// module id = null
// module chunks = 